import React, { useState } from 'react';
import { LogOut } from 'lucide-react';
import { Z_LAYERS } from '../constants/zLayers';
import { useAuthContext } from '../contexts/AuthContext';

/**
 * Web-only account control (ADR-012 Phase 5). The extension's settings page
 * (where sign-out lives) doesn't ship in the web build, so the web app needs
 * its own affordance. Signing out clears the local library by design
 * (account-switch safety, see AuthContext) — the cloud copy stays.
 */
export function WebAccountChip() {
  const { currentUser, signOut } = useAuthContext();
  const [busy, setBusy] = useState(false);

  if (!currentUser) return null;

  const onSignOut = async () => {
    setBusy(true);
    try {
      await signOut();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="fixed bottom-4 left-4 flex items-center gap-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-full shadow px-3 py-1.5 text-xs text-gray-600 dark:text-gray-300"
      style={{ zIndex: Z_LAYERS.TOAST }}
    >
      <span className="max-w-[200px] truncate" title={currentUser.email}>
        {currentUser.email ?? 'Signed in'}
      </span>
      <button
        onClick={() => void onSignOut()}
        disabled={busy}
        className="flex items-center gap-1 text-gray-500 dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400 disabled:opacity-50 focus:outline-none"
        aria-label="Sign out"
      >
        <LogOut className="w-3.5 h-3.5" aria-hidden="true" />
        Sign out
      </button>
    </div>
  );
}
